// extracted by mini-css-extract-plugin
export default {"drag-handler":"DragNDrop-module__drag-handler___Rp5_L"};